/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import dataTestIds from 'constants/data-test-ids';

import Paragraph from 'components/Paragraph/Paragraph';
import { Version } from 'components/Version';
import { useAuth } from 'context/auth-context';

import Button from '../../components/Button/Button';
import ErrorLabel from '../../components/ErrorLabel/ErrorLabel';
import EmailInput from '../../components/forms/EmailInput/EmailInput';
import PasswordInput from '../../components/forms/PasswordInput/PasswordInput';
import Logo from '../../components/Logo/Logo';
import { useTheme } from '../../context/theme-context';

import styles from './LoginScreen.module.scss';

const LoginPage = () => {
  const { formState, register, handleSubmit, errors } = useForm({
    mode: 'onChange'
  });
  const { isValid, dirtyFields } = formState;
  const { logIn, authError, setAuthError } = useAuth();
  const { getCurrentTheme } = useTheme();
  const { homepage_logo, homepage_variant } = getCurrentTheme();
  const history = useHistory();
  const isLeftAlignedLoginVariant = homepage_variant === 'left';

  const onSubmit = ({ email, password }) => {
    logIn(email, password);
  };

  useState(() => setAuthError(null), []);

  return (
    <>
      <Helmet>
        <title>Login Portal</title>
      </Helmet>
      <div>
        <div className={styles.logo}>
          <Logo size="xlarge" url={homepage_logo} altText="logo" />
        </div>
        <form className={styles.login_form} onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.inputs}>
            <EmailInput
              appearance="full-width"
              {...{
                register,
                errors,
                dirtyFields,
                hideIcon: false
              }}
            />
            <PasswordInput
              appearance="full-width"
              {...{ register, errors, dirtyFields }}
            />
            <ErrorLabel error={authError} />
          </div>
          <div className={styles['wrapper-cta']}>
            <Button
              type="button"
              text="Forgot password?"
              appearance="text"
              size="full-width"
              width="100%"
              onClick={() => history.push('/forgot')}
              className={styles.textColor}
            />
            <Button
              type="submit"
              text="Login"
              size="full-width"
              width="100%"
              disabled={!isValid}
            />
          </div>
          <div className={styles['wrapper-cta']}>
            <Paragraph>Don&apos;t have an account?</Paragraph>
            <Button
              type="button"
              text="Register"
              appearance="secondary"
              size="full-width"
              width="100%"
              onClick={() => history.push('/register')}
              dataTestId={dataTestIds.register.register_button}
            />
            <Button
              type="button"
              text="Help"
              appearance="text"
              size="full-width"
              width="100%"
              onClick={() => history.push('/help')}
              className={styles.textColor}
            />
          </div>
        </form>
      </div>
      <Version
        appearance="secondary"
        alignment={isLeftAlignedLoginVariant ? 'left' : 'right'}
      />
    </>
  );
};

export default LoginPage;
